const apiUrl = 'https://system.europlast.hr';
//const apiUrl = 'http://127.0.0.1:8000';
//const apiUrl = 'https://dev.europlast.hr';
//const apiUrl = 'http://localhost:8081'

export default apiUrl;
